const SideNav = props => (
  <ul className={props.className}>
    { props.tabs.map(t =>
      <li key={t.name} className={`tab${props.selected === t.name ? ' active' : ''}`}>
        <a onClick={props.onClick} {...t} />
      </li>
    ) }
  </ul>
)

export default SideNav
